import React from 'react'
import { Switch, Route } from "react-router-dom"
import FlightOffers from './flight-offers.page'
import CreateFlightOffer from './create/create.page'
import EditFlightOffer from './edit/edit.page'

const FlightOfferController = () => {
    return (
        <Switch>
            <Route path="/content/flight-offers/edit/:id" component={EditFlightOffer} />
            <Route path="/content/flight-offers/create" component={CreateFlightOffer} />
            <Route exact path="/content/flight-offers" component={FlightOffers} />
        </Switch>
    )
}

export default FlightOfferController
